import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountUsersTitle: {
    defaultMessage: 'Account Users',
    description: 'Title for the collapsible area where user how many users they would like in there plan.',
    id: 'NFUht7',
  },
  accountUsersIncludedAndAdded: {
    defaultMessage: '{includedUserCount} included, {addedUserCount} added',
    description: 'Summary message for title to describe the amount of users are in the plan',
    id: 'ehF9Va',
  },
  includedUsersDescription: {
    defaultMessage:
      'The {selectedPlanName} plan includes {includedUserCount} account {includedUserCount, plural, one {user} other {users}}. Each additional user is {monthlyPrice}/mo.',
    description: 'Summary message to describe the amount of users included in the selected plan',
    id: '8xWk5Y',
  },
  addOrDeactivateUsers: {
    defaultMessage: 'To add or deactivate users, go to <i>Settings > Manage Users</i>.',
    description: 'Summary message to describe how to change the amount of users.',
    id: '1p+6Zg',
  },
  howToRemoveUser: {
    defaultMessage:
      "If you change to the {planName} plan, you'll be paying for {extraUserCount} additional user {extraUserCount, plural, one {seat} other {seats}}/mo. <a>Manage Users</a>.",
    description:
      'Summary message to describe how many additional users they will be charged and a link to manage active users on the account.',
    id: '2bJ8ZG',
  },
  includedUsersLabel: {
    defaultMessage: 'Included Users',
    description: 'Label text for a number selector to allow a client to add more users to their account',
    id: 'R41DVV',
  },
  additionalUsersLabel: {
    defaultMessage: 'Additional Users',
    description: 'Label text for a number selector to allow a client to add more users to their account',
    id: 'x+Ghkn',
  },
  totalUsersLabel: {
    defaultMessage: 'Total Users',
    description: 'Label text for a number selector to allow a client to add more users to their account',
    id: 'OhHjMu',
  },
  accountActiveUsers: {
    defaultMessage: '<b>Active Accounts:</b> {userCount}',
    description: 'Text to inform the user how many active accounts they have.',
    id: 'RdiNY1',
  },
  userName: {
    description: 'active user name',
    defaultMessage: 'Name',
    id: 'lEAmXA',
  },
  userLastLoginDate: {
    description: 'active user last login date',
    defaultMessage: 'Last Login Date',
    id: 'oQTo3I',
  },
  deactivated: {
    description: 'Text to inform the user if a user in a grid has become deactivated in the subscription plan drawer',
    defaultMessage: '(Deactivated)',
    id: 'wTUGyN',
  },
  currentUser: {
    description: 'Text to inform the client which user is their current user in the subscription plan drawer',
    defaultMessage: '(Current User)',
    id: 'Uj0exy',
  },
  undo: {
    description: 'Text on an action button to Undo deactivation of a user in the subscription management drawer',
    defaultMessage: 'Undo',
    id: 'a6/Gwj',
  },
  deactivate: {
    description: 'Text on an action button to Deactivate a user in the subscription management drawer',
    defaultMessage: 'Deactivate',
    id: 'eqXnZV',
  },
  decrementUserDisabledMessage: {
    description: 'Text that shows when the users number input down arrow is disabled',
    defaultMessage: 'To remove users, please select "Manage Users" in the info banner.',
    id: '7ilpxb',
  },
});
